module.exports = __webpack_public_path__ + "img/16@3x.77a6ed44.png";